/* eslint-disable @typescript-eslint/only-throw-error -- redirect é o contrato do TanStack Router */
import { createFileRoute, redirect } from '@tanstack/react-router';

import { APPROVALS_PATH, DEFAULT_IB_TYPE, legacyInternetBankingSearch } from '@/modules/approvals/route';

// Destino das notificações de pendência (notificationTypeEnum.ts:144-180), que no legado não existe. No novo (A3) a
// rota abre a aba Internet Banking no tipo do `typeOfPendingApprovals`; sem tipo válido, no padrão (Operadores).
export const Route = createFileRoute('/_app/aprovacoes/gestao-aprovacoes/internet-banking')({
  validateSearch: legacyInternetBankingSearch,
  beforeLoad: ({ search }) => {
    const type = search.typeOfPendingApprovals;
    throw redirect({ to: APPROVALS_PATH, search: type && type !== DEFAULT_IB_TYPE ? { tipo: type } : {}, replace: true });
  },
});
